function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.24,17.29a10.72,10.72,0,0,0,.83-1.78,3,3,0,0,0,1.78-2.68A3.05,3.05,0,0,0,22.63,10C22.41,6.24,21.35,2.5,15.9,2.5S9.4,6.22,9.17,10A2.78,2.78,0,0,0,8,12.81a3,3,0,0,0,1.78,2.7,10.2,10.2,0,0,0,.8,1.74c-5.49,1.4-8.28,4.49-8.28,9.2a.76.76,0,0,0,.45.69A34.19,34.19,0,0,0,15.8,29.4a34.19,34.19,0,0,0,13.1-2.26.76.76,0,0,0,.45-.69C29.35,21.79,26.62,18.71,21.24,17.29ZM9.44,12.6a1.29,1.29,0,0,1,.76-1.46l.43-.19,0-.47C10.86,5.7,12.24,4,15.9,4s5,1.76,5.25,6.48l0,.43.37.2a1.56,1.56,0,0,1,.81,1.58c-.07.83-.5,1.41-.85,1.41h-.56l-.16.53c-1,3.13-3.27,5.07-4.88,5.07S12,17.76,11,14.63l-.16-.53H10.3C10,14.1,9.52,13.52,9.44,12.6ZM15.8,27.9A34.29,34.29,0,0,1,3.76,26c.2-3.84,2.69-6.25,7.61-7.38l0-.1A6.17,6.17,0,0,0,15.9,21.2a6.11,6.11,0,0,0,4.46-2.59c4.83,1.14,7.29,3.55,7.48,7.35A34.29,34.29,0,0,1,15.8,27.9Z",
  fill: "#33ba69"
});

var SvgContactIcon = function SvgContactIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact_icon.06a6a020.svg";
export { ForwardRef as ReactComponent };